module.exports = __webpack_public_path__ + "img/android1icon1.cc064f38.png";